export const timeZone = 'Asia/Bangkok'
export const timeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const loadFile = "*File size limit = 10 MB"
export const LongDateTimeFormat = 'ddd MMM D, YYYY HH:mm'



// WEBPACK FOOTER //
// ./src/lib/setting.js